import { Box, makeStyles, Typography } from '@material-ui/core';
import classNames from 'classnames';
import React, { FC } from 'react';
import { ReactComponent as PremiumBonusIcon } from '../assets/icons/books.svg';
import { UserLoyaltyInfoPropsType } from '../model/userLoyaltyInfoType';

const useStyles = makeStyles({
  groupName: {
    color: '#9CA2B0',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14px',
    textTransform: 'uppercase',
  },
  groupText: {
    color: '#14171F',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '14px',
    marginBottom: '4px',
  },
  notificationText: {
    color: '#6ae9c5',
  },
  firstBlock: {
    width: '20%',
  },
  otherBlock: {
    width: '40%',
  },
});

export const UserLoyaltyInfo: FC<UserLoyaltyInfoPropsType> = ({ type, bonus, isNotification }) => {
  const classes = useStyles();

  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="row"
      justifyContent="space-around"
      margin="16px 0"
    >
      <Box
        className={classes.firstBlock}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          height="30px"
          width="30px"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          borderRadius={8}
          border="1px solid #E4E7EC"
          bgcolor={isNotification ? '#FFF' : 'transparent'}
        >
          <PremiumBonusIcon height="24px" width="20px" />
        </Box>
      </Box>
      <Box
        className={classes.otherBlock}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Typography
          className={classNames(classes.groupText, { [classes.notificationText]: isNotification })}
        >
          {type}
        </Typography>
        <Typography className={classes.groupName}>Группа</Typography>
      </Box>
      <Box
        className={classes.otherBlock}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Typography
          className={classNames(classes.groupText, { [classes.notificationText]: isNotification })}
        >
          {bonus}
        </Typography>
        <Typography className={classes.groupName}>Бонусов</Typography>
      </Box>
    </Box>
  );
};
